<template>
  <tile-grid>
    <service-tile
      v-for="service in getDevices"
      :key="service.id"
      :service="service"
      :selected="false"
    />
  </tile-grid>
</template>

<script>
import { mapGetters } from 'vuex';
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import ServiceTile from '@/components/services/service/ServiceTile.vue';
import TileGrid from '@/components/utils/TileGrid';

export default {
  name: 'Devices',
  mixins: [
    BreadcrumbsManager,
  ],
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$t('devices'),
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'getDevices',
    ]),
  },
  components: {
    TileGrid,
    ServiceTile,
  },
};
</script>

<style scoped>

</style>
